// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mobile-layout .site-content {
  height: 100%;
  padding-top: 55px;
}

#mobile-layout .site-content > .ui.message {
  margin: 10px 5px;
}

/* Site header menu */
#mobile-layout .site-header {
  height: 55px;
}

#mobile-layout .site-header .header-content .label {
  margin-left: 0px;
}

/* Navigation menu */
#mobile-menu {
  z-index: 100 !important;
  max-width: 200px;
  padding-bottom: 10px;
}

#mobile-menu i.navigation.icon {
  float: none !important;
  margin: 0 0.5em 0 0 !important;
}

#mobile-menu .separator {
  height: 20px;
}

/* Semantic has issues with right vertical menu */
#mobile-menu .ui.dropdown.right .menu {
  right: 100%;
  border-radius: 0.28571429rem 0 0.28571429rem 0.28571429rem;
  left: auto !important;
}

#mobile-menu .icon-panel {
  display: flex;
  margin: 10px 20px 10px 20px;
  align-items: baseline;
}

#mobile-menu .icon-panel .touch-icons {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  align-items: center;
}

#mobile-menu .icon-panel .touch-icons > .icon {
  margin: 0px 4px !important;
}

#mobile-menu .icon-panel i {
  float: none !important;
}

/* Dialogs */
.download-dialog .ui.dropdown a.item {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/main/style.mobile.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,0DAA0D;EAC1D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":["#mobile-layout .site-content {\r\n  height: 100%;\r\n  padding-top: 55px;\r\n}\r\n\r\n#mobile-layout .site-content > .ui.message {\r\n  margin: 10px 5px;\r\n}\r\n\r\n/* Site header menu */\r\n#mobile-layout .site-header {\r\n  height: 55px;\r\n}\r\n\r\n#mobile-layout .site-header .header-content .label {\r\n  margin-left: 0px;\r\n}\r\n\r\n/* Navigation menu */\r\n#mobile-menu {\r\n  z-index: 100 !important;\r\n  max-width: 200px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n#mobile-menu i.navigation.icon {\r\n  float: none !important;\r\n  margin: 0 0.5em 0 0 !important;\r\n}\r\n\r\n#mobile-menu .separator {\r\n  height: 20px;\r\n}\r\n\r\n/* Semantic has issues with right vertical menu */\r\n#mobile-menu .ui.dropdown.right .menu {\r\n  right: 100%;\r\n  border-radius: 0.28571429rem 0 0.28571429rem 0.28571429rem;\r\n  left: auto !important;\r\n}\r\n\r\n#mobile-menu .icon-panel {\r\n  display: flex;\r\n  margin: 10px 20px 10px 20px;\r\n  align-items: baseline;\r\n}\r\n\r\n#mobile-menu .icon-panel .touch-icons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  flex: 1;\r\n  align-items: center;\r\n}\r\n\r\n#mobile-menu .icon-panel .touch-icons > .icon {\r\n  margin: 0px 4px !important;\r\n}\r\n\r\n#mobile-menu .icon-panel i {\r\n  float: none !important;\r\n}\r\n\r\n/* Dialogs */\r\n.download-dialog .ui.dropdown a.item {\r\n  display: flex !important;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
